export enum TokenType {
    NONE,
    ACCESS,
    REFRESH,
    THG_API_KEY,
}
